import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Link from "@insightfulscience/atomic-react/Link";
import PageTitle from "@insightfulscience/smart-react/PageTitle";
import routes from "../../routes";
import ErrorLayout from "./ErrorLayout";
import ErrorDetails from "./ErrorDetails";

function Error500({ error }: { error: object }) {
	return (
		<ErrorLayout extra={<ErrorDetails error={error} />}>
			<PageTitle title="Something Went Wrong - OMIQ" />
			<Heading Tag="h1" size="xl" center className="mb-6 text-color-3">
				Something went wrong
			</Heading>
			<Paragraph size="s" center className="">
				We’re sorry. Something has gone wrong with the application.
				<br />
				<br />
				Please try again later or{" "}
				<Link href={routes.external.help} size="s">
					contact us
				</Link>{" "}
				for further assistance.
			</Paragraph>
		</ErrorLayout>
	);
}

export default Error500;
